import moment from 'moment'
import { getServiceCosts } from './getServiceCosts'
import { getTotalCost } from './getTotalCost'
import { formatPrice } from 'Rentlio/components/utils/Price/price'
import { FIRST_NIGHT } from 'Rentlio/utils/CancellationPolicyFeeTypeEnum'
import { isDateInPast } from 'Rentlio/helper/isDateInPast'

function calculatePercentageValue(value, percent) {
  return Number(value * (percent / 100))
}

const isAmountWillBePaidDaysBeforeInThePast = (item, reservationArrival) =>
  reservationArrival
    ? isDateInPast(
        moment
          .unix(reservationArrival)
          .clone()
          .subtract(item.amountWillBePaidDaysBefore ? +item.amountWillBePaidDaysBefore : 0, 'days')
      )
    : false

export function getPrePaymentDetails(state) {
  const { basket, request } = state

  if (!basket?.length) {
    return {
      prepaymentAmount: 0,
      prepaymentPercentage: 0
    }
  }

  const getPrePaymentAmount = basket
    .map(item => {
      let servicesCost = 0
      item.services.map(service => {
        if (service.quantity === 0) {
          return
        }
        servicesCost += getServiceCosts(service, state.request)
      })

      if (isAmountWillBePaidDaysBeforeInThePast(item, request?.from)) {
        return item.totalRate + servicesCost
      }

      if (item.cancellationPolicy?.prepaymentAmountType === FIRST_NIGHT) {
        return item.firstNightPrice
      }

      if (item.cancellationPolicy?.prepaymentAmount && Number(item.cancellationPolicy.prepaymentAmount) > 0) {
        return calculatePercentageValue(item.totalRate + servicesCost, item.cancellationPolicy.prepaymentAmount)
      }
      return 0
    })
    .reduce((sum, value) => sum + value, 0)

  const getPrePaymentPercentage = formatPrice((getPrePaymentAmount / getTotalCost(state).accomodation) * 100)

  return {
    prepaymentAmount: getPrePaymentAmount,
    prepaymentPercentage: getPrePaymentPercentage
  }
}
